<template>
    <div>

        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>模具列表</b></p>

                <p style="display:inline-block;line-height: 40px;margin:5px 0">
                    <el-radio-group v-model="statusSearch" @input="searchByStatus">
                        <el-radio-button label="0">待产</el-radio-button>
                        <el-radio-button label="1">生产中</el-radio-button>
                        <el-radio-button label="2">暂停</el-radio-button>
                        <el-radio-button label="3">完成</el-radio-button>

                        <el-radio-button label="-1">全部</el-radio-button>
                    </el-radio-group>
                </p>
            </div>
            
            <el-table :data="orderList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="moldTable"
                highlight-current-row>
                <el-table-column type="selection" width="45" class="checkColumn">
                </el-table-column>
                <el-table-column prop="orderCode" label="订单编号" min-width="13%">
                </el-table-column>
                <el-table-column prop="orderCount" label="订单数量" min-width="8%" align="center">
                </el-table-column>
                <el-table-column prop="customer" label="客户" min-width="10%">
                </el-table-column>

                <el-table-column prop="productName" label="产品名称" min-width="15%">
                </el-table-column>
                <el-table-column prop="moldCode" label="模具编号" min-width="14%">
                </el-table-column>

                <el-table-column prop="deliveryTime" label="交货日期" min-width="10%">
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="7%">
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="23%">
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="prev, pager, next" :total="total"
                    @current-change="pageClick" hide-on-single-page>
                </el-pagination>
            </div>
        </div>

        <div>
            <p></p>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>BOM列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="download">下载模板</el-button>
                </p>
                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-upload action="#" :http-request="upload" :show-file-list="false" :disabled="addButtonDisable">
                        <el-button round type="success" :disabled="addButtonDisable">批量导入</el-button>
                        <span>-</span>
                    </el-upload>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="openDialog" type="success" :disabled="addButtonDisable">新增BOM</el-button>
                    <span>-</span>
                </p>

                <p style="display:inline-block;line-height: 40px;margin:5px 0">
                    <el-radio-group v-model="bigTypeSearch" @input="searchByBigType">
                        <el-radio-button label="0">产品设计</el-radio-button>
                        <el-radio-button label="1">模具设计</el-radio-button>
                        <el-radio-button label="2">模芯</el-radio-button>
                        <el-radio-button label="3">模架</el-radio-button>
                        <el-radio-button label="-1">全部</el-radio-button>
                    </el-radio-group>
                </p>
            </div>

            <el-table :data="bomList" row-key="id" style="width: 100%">
                <el-table-column type="index" width="40">
                </el-table-column>
                <el-table-column prop="moldCode" label="模具编号" min-width="15%">
                </el-table-column>
                <el-table-column prop="bomBigTypeDesc" label="BOM大类" min-width="10%">
                </el-table-column>
                <el-table-column prop="sparePartCode" label="配件编号" min-width="15%">
                </el-table-column>
                <el-table-column prop="sparePartName" label="配件名称" min-width="14%">
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="7%">
                </el-table-column>

                <el-table-column prop="maker" label="创建人" min-width="7%">
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" min-width="11%">
                </el-table-column>

                <el-table-column prop="remark" label="备注" min-width="21%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                            更改
                        </el-button>
                        <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                            {{ addButtonDisable ? '' : '删除' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <!-- <div>
                <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="prev, pager, next" :total="total"
                    @current-change="bomPageClick" hide-on-single-page>
                </el-pagination>
            </div> -->

            <el-dialog title="BOM详情" :visible.sync="dialogFormVisible" width="60%">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                    <el-form-item label="模具编号" required :label-width="formLabelWidth">
                        <el-input v-model="form.moldCode" autocomplete="off" style="width:220px" disabled></el-input>
                    </el-form-item>
                    <!-- <div style="width:350px;display: inline-block;"></div> -->
                    <el-form-item label="BOM大类" required :label-width="formLabelWidth">
                        <el-select v-model="form.bomBigType" placeholder="请选择" style="width:220px"
                            :disabled="bigTypeDisable" @change="selectBomBigType">
                            <el-option v-for="item in form.bigTypeList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="配件编号" required :label-width="formLabelWidth" prop="sparePartCode">
                        <el-input v-model="form.sparePartCode" autocomplete="off" style="width:220px"
                            :disabled="sparePartCodeDisable"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="配件名称" :label-width="formLabelWidth">
                        <el-input v-model="form.sparePartName" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item> -->
                    <el-form-item label="配件名称" required :label-width="formLabelWidth">
                        <el-select v-model="form.sparePartName" placeholder="请选择" style="width:220px"
                            @change="selectSparePartName">
                            <el-option v-for="item in form.sparePartList" :key="item.value" :label="item.sparePartName"
                                :value="item.sparePartName">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="备注" :label-width="formLabelWidth">
                        <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addMoldBOM('ruleForm')" v-show="saveButtonVisible">保 存</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "MoldBOM",
    data() {
        return {
            gc: 0,
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            statusSearch: 0,
            orderList: [],
            dialogFormVisible: false,
            batchDialogVisible: false,
            saveButtonVisible: true,
            form: {
                id: '',
                moldCode: '',
                bigTypeList: [{
                    value: 0,
                    label: '产品设计'
                }, {
                    value: 1,
                    label: '模具设计'
                }, {
                    value: 2,
                    label: '模芯'
                }, {
                    value: 3,
                    label: '模架'
                }],
                bomBigType: '',

                sparePartList: [],

                sparePartCode: '',
                sparePartName: '',
                status: 0,
                maker: '',
                remark: ''
            },
            bomBigTypeDesc: '',
            bigTypeDisable: false,
            formLabelWidth: '120px',
            bomList: [],
            sparePartCodeDisable: true,
            addButtonDisable: true,
            batchButtonDisable: true,
            bomBatchAddList: [],
            rules: {
                sparePartCode: [
                    { required: true, message: '请输入配件编号', trigger: 'blur' },
                    { required: true, message: '请输入配件编号', trigger: 'change' }
                ]
            },
            bigTypeSearch: 0,
            pageIndex:0,
            pageNum:5,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        searchByStatus(val) {
            this.getAllOrder(val)
            this.bomList = []
            this.form.moldCode = ''
        },
        selectClick(selection, row) {
            this.$refs.moldTable.clearSelection()
            this.$refs.moldTable.toggleRowSelection(row)
            this.form.moldCode = row.moldCode
            this.getAllBOM(this.bigTypeSearch)
            //模具为待装配状态可以新增BOM
            if (row.assemblyProgress == 0) {
                this.addButtonDisable = false
                this.batchButtonDisable = false
            } else {//否则不能
                this.addButtonDisable = true
                this.batchButtonDisable = true
            }
        },
        rowClick(row) {
            //console.log(row)
            this.$refs.moldTable.clearSelection()
            this.$refs.moldTable.toggleRowSelection(row)
            this.form.moldCode = row.moldCode
            this.getAllBOM(this.bigTypeSearch)
            if (row.assemblyProgress == 0) {
                this.addButtonDisable = false
                //this.batchButtonDisable=false
            } else {
                this.addButtonDisable = true
                //this.batchButtonDisable=true
            }
        },
        handleClick(row) {
            //console.log(row);
            this.form.id = row.id

            this.form.moldCode = row.moldCode
            this.form.bomBigType = row.bomBigType
            this.form.sparePartCode = row.sparePartCode
            this.form.sparePartName = row.sparePartName
            this.form.status = null
            this.form.remark = row.remark

            this.sparePartCodeDisable = true
            this.bigTypeDisable = true
            this.dialogFormVisible = true
        },
        openDialog() {
            if (this.form.moldCode == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择模具订单'
                })
                return
            }

            this.getAllBaseBOM(this.bigTypeSearch)

            this.form.id = ''
            this.form.bomBigType = this.bigTypeSearch
            if (this.bigTypeSearch == -1) {
                this.form.bomBigType = ''
            }

            this.form.sparePartCode = ''
            this.form.sparePartName = ''
            this.form.status = 0
            this.form.maker = this.userId
            this.form.remark = ''

            this.sparePartCodeDisable = true
            this.bigTypeDisable = false
            this.dialogFormVisible = true

        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeMoldBOM(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        download() {
            this.$axios({
                method: "get",
                url: "/shiro/mold/bom/download",
                data: {

                }, headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "BOM导入模板.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        upload(f) {
            // console.log(f)
            const form = new FormData()
            form.append('file', f.file)
            form.append('maker', this.userId)
            form.append('companyId', this.companyId)
            this.$axios({
                method: "post",
                url: "/shiro/mold/bom/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data
                this.getAllBOM(this.bigTypeSearch)
            })
        },
        searchByBigType(val) {

            if (this.form.moldCode == '') {
                this.$message({
                    type: 'info',
                    message: '请先选择模具订单'
                })
                return
            }

            // console.log('val')
            // console.log(val)
            // console.log(parseInt(val))

            this.bigTypeSearch = parseInt(val)
            this.getAllBOM(this.bigTypeSearch)

        },
        addMoldBOM(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.$axios({
                        method: "post",
                        url: "/shiro/mold/bom/add",
                        data: {
                            id: this.form.id,
                            moldCode: this.form.moldCode,
                            bomBigType: this.form.bomBigType,
                            sparePartCode: this.form.sparePartCode,
                            sparePartName: this.form.sparePartName,
                            status: this.form.status,
                            maker: this.form.maker,

                            remark: this.form.remark,
                            companyId: this.companyId
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                            return
                        }

                        this.dialogFormVisible = false
                        this.getAllBOM(this.bigTypeSearch)
                    })
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });

        },
        getAllBOM(val) {
            this.$axios({
                method: "post",
                url: "/shiro/mold/bom/getAll",
                data: {
                    moldCode: this.form.moldCode,
                    bomBigType: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.bomList = data.data
                for (let i in this.bomList) {

                    this.bomList[i].createdTime = this.$moment(this.bomList[i].createdTime).format("YYYY-MM-DD")

                    if (this.bomList[i].status == 0) {
                        this.bomList[i].status = '待加工'
                    } else if (this.bomList[i].status == 1) {
                        this.bomList[i].status = '加工中'
                    } else if (this.bomList[i].status == 2) {
                        this.bomList[i].status = '暂停'
                    } else {
                        this.bomList[i].status = '完成'
                    }

                    if (this.bomList[i].bomBigType == 0) {
                        this.bomList[i].bomBigTypeDesc = '产品设计'
                    } else if (this.bomList[i].bomBigType == 1) {
                        this.bomList[i].bomBigTypeDesc = '模具设计'
                    } else if (this.bomList[i].bomBigType == 2) {
                        this.bomList[i].bomBigTypeDesc = '模芯'
                    } else {
                        this.bomList[i].bomBigTypeDesc = '模架'
                    }
                }
            })
        },
        removeMoldBOM(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/mold/bom/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAllBOM(this.bigTypeSearch)
            })
        },
        getAllOrder(val) {

            const formData = new FormData()
            formData.append('status', val)
            formData.append('assemblyProgress', 0)
            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)
            
            this.$axios({
                method: "post",
                url: "/shiro/mold/order/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                }

                this.orderList = data.data
                this.total = this.orderList[0].total
                this.pageCount = this.total % this.pageNum == 0 ? this.total % this.pageNum : this.total % this.pageNum + 1
                for (let i in this.orderList) {

                    this.orderList[i].deliveryTime = this.$moment(this.orderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.orderList[i].status == 0) {
                        this.orderList[i].status = '待产'
                    } else if (this.orderList[i].status == 1) {
                        this.orderList[i].status = '生产中'
                    } else if (this.orderList[i].status == 2) {
                        this.orderList[i].status = '暂停'
                    } else {
                        this.orderList[i].status = '完成'
                    }
                }
            })
        },
        //行拖拽
        rowDrop() {
            const tbody = document.querySelectorAll('.el-table__body tbody')[1]
            // console.log('tbody')
            // console.log(tbody)

            const _this = this
            // console.log('_this')
            // console.log(_this)

            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return

                    _this.bomList.splice(newIndex, 0, _this.bomList.splice(oldIndex, 1)[0])

                    var newArray = _this.bomList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)

                    _this.bomList = []

                    _this.$nextTick(function () {
                        _this.bomList = newArray

                        this.sort(newArray)
                    })

                }
            })

        },
        sort(val) {
            // console.log('sort()')
            const moldBOMVOList = []
            if (val.length > 0) {

                for (let i in val) {
                    // moldBOMVOList.push({id:val[i].id,bomSort:val[i].bomSort})
                    delete val[i].bomBigTypeDesc
                    delete val[i].status
                }
                // console.log('moldBOMVOList')
                // console.log(moldBOMVOList)
            }
            // console.log('newVal')
            // console.log(val)
            const form = new FormData()

            form.append('moldBOMVOList', moldBOMVOList.toString())
            // form.append('id','123456')
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/mold/bom/sort",
                data: {
                    moldBOMVOList: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

            })
        },
        getAllBaseBOM(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/bom/getAll",
                data: {
                    bomBigType: val,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.form.sparePartList = data.data
                // console.log('sparePartList')
                // console.log(this.form.sparePartList)

            })
        },
        selectBomBigType(value) {
            // console.log('selectBomBigType')
            // console.log(value)
            this.bigTypeSearch = value
            this.getAllBaseBOM(this.bigTypeSearch)
        },
        selectSparePartName(value) {
            // console.log('selectSparePartName')
            // console.log(value)
            const index = this.form.sparePartList.findIndex(obj => obj.sparePartName == value)
            // console.log('index')
            // console.log(index)
            this.form.sparePartCode = this.form.sparePartList[index].sparePartCode
        },
        pageClick(currentPage){
            // console.log('pageClick()')
            // console.log(currentPage)
            this.pageIndex=(currentPage-1)*this.pageNum
            this.getAllOrder(this.statusSearch)
        }
    },
    mounted() {
        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        this.rowDrop()//行拖拽

        this.getAllOrder(this.statusSearch)
        //console.log('mmm')
        //console.log(this.$el.$refs)
        //console.log(this.$refs.moldTable.tableData[0])

    },
    beforeUpdate() {
        //console.log('bububu')
        //console.log(this.$refs.moldTable.tableData[0])
    },
    updated() {
        var checkBoxEle = document.getElementsByClassName("el-checkbox")
        //console.log('ududud')
        //console.log(checkColumnEle[0])
        checkBoxEle[0].innerHTML = ''

        //console.log(this.gc)
        if (this.gc == 1) {
            // console.log(this.$refs.moldTable)
            if (this.$refs.moldTable != null && this.$refs.moldTable.tableData.length > 0) {
                this.$refs.moldTable.toggleRowSelection(this.$refs.moldTable.tableData[0])
                this.form.moldCode = this.$refs.moldTable.tableData[0].moldCode
                this.getAllBOM(this.bigTypeSearch)

                if (this.$refs.moldTable.tableData[0].assemblyProgress == 0) {
                    this.addButtonDisable = false
                }
            }

        }
        this.gc++
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>